export const SUBSIDIZED_MORTGAGE_OPTION_VALUE = 'subsidizedMortgage';
